export default "__VITE_ASSET__BhSQj$Ap__";